module.exports = __webpack_public_path__ + "static/media/photo-instructions2.58d97fa5.png";